import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Button , Modal , Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../../constants/themeColor';
import coffeeGreenTeaImage from '../../../assets/home/coffee_green_tea.png';
import cocina3Image from '../../../assets/home/cocina3.png';
import fatTigerImage from '../../../assets/home/fat_tiger.png';
import checkersGraph from '../../../assets/pattern/tiny-checkers.svg';
import cocina3_0 from '../../../assets/home/case/cocina3/0.jpg';
import cocina3_1 from '../../../assets/home/case/cocina3/1.jpg';
import cocina3_2 from '../../../assets/home/case/cocina3/2.jpg';
import cocina3_3 from '../../../assets/home/case/cocina3/3.jpg';
import cocina3_4 from '../../../assets/home/case/cocina3/4.jpg';
import fat_tiger_1 from '../../../assets/home/case/fat_tiger/1.jpg';
import fat_tiger_2 from '../../../assets/home/case/fat_tiger/2.jpg';
import fat_tiger_3 from '../../../assets/home/case/fat_tiger/3.jpg';
import fat_tiger_4 from '../../../assets/home/case/fat_tiger/4.jpg';

const styles = {
  container : {
		padding : '5px 0px',
    backgroundColor : ThemeColorSetting.black,
    backgroundImage: 'url(' +checkersGraph+ ')',
		backgroundSize : '25px 25px',
		backgroundRepeat : 'repeat'
  },
  caseContainer : {
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center'
  },
  header : {
    color : ThemeColorSetting.white,
    textAlign : 'center'
  },
  description : {
    color : 'white',
    fontSize : '18px'
  }
};

class CaseStudy extends Component {
  constructor(props){
    super(props);
    this.state = {
      cases : [
        { 
					name : 'coffeeGreenTea' , 
					monthlyFee : '150' , 
					image : coffeeGreenTeaImage,
					address : 'coffeeGreenTeaAddress'
				},
        { 
					name : 'cocina3' , 
					monthlyFee : '250' , 
					image : cocina3Image,
					address : 'cocina3Address',
					modal : false,
					images : [
						cocina3_0,
						cocina3_1,
						cocina3_2,
						cocina3_3,
						cocina3_4
					]
				},
        { 
					name : 'fatTiger' , 
					monthlyFee : '150' , 
					image : fatTigerImage ,
					address : 'fatTigerAddress',
					modal : false,
					images : [
						fat_tiger_1,
						fat_tiger_2,
						fat_tiger_3,
						fat_tiger_4
					]
				}
      ]
    }
  }
  renderCase(thisCase,index){
    const { string } = this.props;
		let { cases } = this.state;
    return(
      <Grid.Column key={thisCase.name} style={styles.caseContainer}>
				{
					(thisCase.images) ? 
					<Modal 
						open={thisCase.modal} 
						trigger={
							<Image onClick={()=>{
								cases[index]['modal'] = true;
								this.setState({ cases : cases  });
							}} src={thisCase.image} size='medium' style={{ cursor : 'pointer' }}/>
						} 
						basic
					>
						{thisCase.images.map((image,index)=><Image key={index} src={image}/>)}
						<Modal.Actions>
							<Button
								size='large'
								fluid
								style={{ margin : 'auto'}}
								onClick={()=>{
									cases[index]['modal'] = false;
									this.setState({ cases : cases  });
								}}
							>
								{string['close']} <Icon name='close' />
							</Button>
						</Modal.Actions>
					</Modal> : 
					<Image src={thisCase.image} size='medium'/>
				}
        <h1 style={styles.header}>{string[thisCase.name]}</h1>
        <p style={styles.description}>
					<Icon name='marker'/>
					{`${string['resAddress']} : ${string[thisCase.address]}`}
				</p>
        <p style={styles.description}>
					<Icon name='money'/>
					{`${string['monthlyFee']} : $${thisCase.monthlyFee}`}
				</p>
      </Grid.Column>
    )
  }
  render() {
    const { string } = this.props;
    const { cases } = this.state;
    return(
      <Grid.Row columns='3' style={styles.container}>
        {cases.map((thisCase,index)=>this.renderCase(thisCase,index))}
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(CaseStudy)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/case/caseStudy.js
 **/